import { SearchType } from "@app/enums/SearchType";
import { onMounted, Ref, ref } from "vue";
import { useGenerateSearchTypeUrl } from "./useGenerateSearchTypeUrl";
import { navigateTo } from "nuxt/app";

export const useSearchTypeRedirect = (searchType: SearchType): {loading: Ref<boolean>} => {
	const loading = ref(false);

	onMounted( async () => {
		const generatedUrl = await useGenerateSearchTypeUrl(searchType);
		await navigateTo(generatedUrl, {redirectCode: 301, replace: true, external: true});
		loading.value = true;
	});

	return { loading };
};
